// import { ADDADMIN, ERROR, FORGETPASSWORD } from '../actions/ADDADMIN_action';
import { LISTLANUGAGESERROR, LISTLANUGAGESREQUEST, LISTLANUGAGESSUCCESS } from './../actions/actionTypes'
 
const initialState = {
    requestDone: false,
    isFetched: false,
    isFetching : false,
    err : false,
    message:'',
    languages: [],
    total : 0,
  };
  
  // receiving response sent by action according to type of action
  export default function listLanguages(state = initialState, action) {
      //console.log(action,'action')
      let { payload } = action
    switch (action.type) {
        case LISTLANUGAGESREQUEST:
          return { 
            requestDone: false,
            isFetched: false,
            isFetching : true,
            err : false,
            message:'',
            languages: [],
            total : 0
           };
          break;
        case LISTLANUGAGESSUCCESS:
            //console.log('========in switch', payload.users)
        return { 
            requestDone: true,
            isFetched: true,
            isFetching : false,
            err : false,
            message:'',
            languages: payload.data,
        };
        break;
  
        case LISTLANUGAGESERROR:
        return { 
            requestDone: true,
            isFetched: false,
            isFetching : false,
            err : true,
            message: payload.message,
            languages : []
        };
        break;
        
      default:
        return state;
    }
  }
